<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3533')}}</div>
                <div style="display: grid; grid-template-columns: 2fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div v-if="showTractionSheaveDetails==false && showDeliverRope==true">
                            <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                                <div>
                                    <div class="ZAfont_family ZAfont_size">{{$t('3038')}} | {{$t('1182')}}:</div>
                                </div>
                                <div v-if="tractionSheave_DiameterAndWidthSelection.length==0 || tractionSheave_DiameterAndWidthSelection.length>4">
                                    <select v-model="selectedTractionSheave_DiameterAndWidth" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedTractionSheave_DiameterAndWidth==null, my_input_background_color_at_validInput:selectedTractionSheave_DiameterAndWidth!=null}">
                                        <option value="null" hidden>{{$t('3174')}}</option>
                                        <option value="" hidden>{{$t('3174')}}</option>
                                        <option v-for="diameterAndWidth in tractionSheave_DiameterAndWidthSelection" v-bind:value="diameterAndWidth">{{diameterAndWidth.text}}</option>
                                    </select>
                                </div>
                                <div v-if="tractionSheave_DiameterAndWidthSelection.length>0 && tractionSheave_DiameterAndWidthSelection.length<=4">
                                    <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedTractionSheave_DiameterAndWidth==null, my_input_background_color_at_validInput:selectedTractionSheave_DiameterAndWidth!=null}">
                                        <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                            <li v-for="diameterAndWidth in tractionSheave_DiameterAndWidthSelection">
                                                <input type="checkbox" @input="change_Selected_atElementOf_diameterAndWidth(diameterAndWidth)" v-bind:checked="diameterAndWidth.selected" v-bind:disabled="diameterAndWidth.selected" />
                                                <span style="margin-left:10px">{{diameterAndWidth.text}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 30px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3452')}} KID:</div>
                            </div>
                            <div v-if="customerIdKidSelection.length==0 || customerIdKidSelection.length>4">
                                <select v-model="selectedCustomerIdKid" class="my_select" style="width:100%" v-bind:disabled="deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: customerIdKidSelection.length > 0 && selectedCustomerIdKid==null, my_input_background_color_at_validInput: customerIdKidSelection.length == 0 || selectedCustomerIdKid!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="customerIdKid in customerIdKidSelection" v-bind:value="customerIdKid">
                                        {{customerIdKid.text.useTextKey?$t(customerIdKid.text.textKey):customerIdKid.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="customerIdKidSelection.length>0 && customerIdKidSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedCustomerIdKid==null, my_input_background_color_at_validInput:selectedCustomerIdKid!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="customerIdKid in customerIdKidSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_customerIdKid(customerIdKid)" v-bind:checked="customerIdKid.selected" v-bind:disabled="customerIdKid.selected || deliverRopeDisabled==true" />
                                            <span style="margin-left:10px">{{customerIdKid.text.useTextKey?$t(customerIdKid.text.textKey):customerIdKid.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3533')}} {{$t('3395')}}:</div>
                            </div>
                            <div v-if="deliverRopeSelection.length==0 || deliverRopeSelection.length>4">
                                <select v-model="selectedDeliverRope" class="my_select" style="width:100%" v-bind:disabled="deliverRopeSelectionDisabled==true" v-bind:class="{my_input_border_at_invalidInput: selectedDeliverRope==null, my_input_background_color_at_validInput:selectedDeliverRope!=null}">
                                    <option value="null" hidden>{{$t('3174')}}</option>
                                    <option value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="deliverRope in deliverRopeSelection" v-bind:value="sheaveProfile">{{deliverRope.text.textUI}}</option>
                                </select>
                            </div>
                            <div v-if="deliverRopeSelection.length>0 && deliverRopeSelection.length<=4">
                                <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedDeliverRope==null, my_input_background_color_at_validInput:selectedDeliverRope!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="deliverRope in deliverRopeSelection">
                                            <div>
                                                <input type="checkbox" @input="change_Selected_atElementOf_deliverRope(deliverRope)" v-bind:checked="deliverRope.selected" v-bind:disabled="deliverRope.selected || deliverRopeSelectionDisabled==true" />
                                                <span style="margin-left:10px">{{deliverRope.text.useTextKey?$t(deliverRope.text.textKey):deliverRope.text.textUI}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3534')}}:</div>
                            </div>
                            <div v-if="tractionSheaveCoverSelection.length==0 || tractionSheaveCoverSelection.length>4">
                                <select v-model="selectedTractionSheaveCover" class="my_select" style="width:100%" v-bind:disabled="tractionSheaveCoverSelection.length || tractionSheaveCoverSelectionDisabled==true">
                                    <option v-for="tractionSheaveCover in tractionSheaveCoverSelection" v-bind:value="tractionSheaveCover">{{tractionSheaveCover.text.text}}</option>
                                </select>
                            </div>
                            <div v-if="tractionSheaveCoverSelection.length>0 && tractionSheaveCoverSelection.length<=4">
                                <div style="display: grid;">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="tractionSheaveCover in tractionSheaveCoverSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_tractionSheaveCover(tractionSheaveCover)" v-bind:checked="tractionSheaveCover.selected" v-bind:disabled="tractionSheaveCover.selected || tractionSheaveCoverSelectionDisabled==true" />
                                            <span style="margin-left:10px">{{tractionSheaveCover.text.text}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3535')}}:</div>
                            </div>
                            <div v-if="positionMotorSelection.length==0 || positionMotorSelection.length>4">
                                <select v-model="selectedPositionMotor" class="my_select" style="width:100%" v-bind:disabled="positionMotorSelection.length==0 || selectedCustomerIdKid==null || selectedCustomerIdKid=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: positionMotorSelection.length > 0 && selectedPositionMotor==null, my_input_background_color_at_validInput: positionMotorSelection.length==0 || selectedPositionMotor!=null}">
                                    <option v-if="positionMotorSelection.length>0" value="null" hidden>{{$t('3174')}}</option>
                                    <option v-if="positionMotorSelection.length>0" value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="positionMotor in positionMotorSelection" v-bind:value="positionMotor">
                                        {{positionMotor.text.useTextKey?$t(positionMotor.text.textKey):positionMotor.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="positionMotorSelection.length>0 && positionMotorSelection.length<=4">
                                <div style="display: grid;" v-bind:disabled="positionMotorSelection.length==0 || selectedCustomerIdKid==null || selectedCustomerIdKid=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: positionMotorSelection.length > 0 && selectedPositionMotor==null, my_input_background_color_at_validInput: positionMotorSelection.length==0 || selectedPositionMotor!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="positionMotor in positionMotorSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_positionMotor(positionMotor)" v-bind:checked="positionMotor.selected" v-bind:disabled="positionMotor.selected || deliverRopeDisabled==true" />
                                            <span style="margin-left:10px">{{positionMotor.text.useTextKey?$t(positionMotor.text.textKey):positionMotor.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3536')}}:</div>
                            </div>
                            <div v-if="ropePullSelection.length==0 || ropePullSelection.length>4">
                                <select v-model="selectedRopePull" class="my_select" style="width:100%" v-bind:disabled="selectedPositionMotor==null || selectedPositionMotor=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: ropePullSelection.length > 0 && selectedRopePull==null, my_input_background_color_at_validInput: ropePullSelection.length==0 || selectedRopePull!=null}">
                                    <option v-if="ropePullSelection.length>0" value="null" hidden>{{$t('3174')}}</option>
                                    <option v-if="ropePullSelection.length>0" value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="ropePull in ropePullSelection" v-bind:value="ropePull">
                                        {{ropePull.text.useTextKey?$t(ropePull.text.textKey):ropePull.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="ropePullSelection.length>0 && ropePullSelection.length<=4">
                                <div style="display: grid;" v-bind:disabled="selectedCustomerIdKid==null || selectedCustomerIdKid=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: ropePullSelection.length > 0 && selectedRopePull==null, my_input_background_color_at_validInput: ropePullSelection.length==0 || selectedRopePull!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="ropePull in ropePullSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_ropePull(ropePull)" v-bind:checked="ropePull.selected" v-bind:disabled="ropePull.selected || deliverRopeDisabled==true" />
                                            <span style="margin-left:10px">{{ropePull.text.useTextKey?$t(ropePull.text.textKey):ropePull.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3537')}}:</div>
                            </div>
                            <div v-if="adjustabilitySelection.length==0 || adjustabilitySelection.length>4">
                                <select v-model="selectedAdjustability" class="my_select" style="width:100%" v-bind:disabled="selectedRopePull==null || selectedRopePull=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: adjustabilitySelection.length > 0 && selectedAdjustability==null, my_input_background_color_at_validInput: adjustabilitySelection.length==0 || selectedAdjustability!=null}">
                                    <option v-if="adjustabilitySelection.length>0" value="null" hidden>{{$t('3174')}}</option>
                                    <option v-if="adjustabilitySelection.length>0" value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="adjustability in adjustabilitySelection" v-bind:value="sheaveProfile">{{adjustability.text.textUI}}</option>
                                </select>
                            </div>
                            <div v-if="adjustabilitySelection.length>0 && adjustabilitySelection.length<=4">
                                <div v-bind:class="{my_input_border_at_invalidInput: adjustabilitySelection.length > 0 && selectedAdjustability==null, my_input_background_color_at_validInput: adjustabilitySelection.length==0 || selectedAdjustability!=null}">
                                    <ul class="my_inputCheckbox2 ZAfont_family ZAfont_size">
                                        <li v-for="adjustability in adjustabilitySelection">
                                            <div>
                                                <input type="checkbox" @input="change_Selected_atElementOf_adjustability(adjustability)" v-bind:checked="adjustability.selected" v-bind:disabled="adjustability.selected || deliverRopeDisabled==true" />
                                                <span style="margin-left:10px">{{adjustability.text.useTextKey?$t(adjustability.text.textKey):adjustability.text.textUI}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3538')}}:</div>
                            </div>
                            <div v-if="thirdRopeGuardSelection.length==0 || thirdRopeGuardSelection.length>4">
                                <select v-model="selectedThirdRopeGuard" class="my_select" style="width:100%" v-bind:disabled="selectedPositionMotor==null || selectedPositionMotor=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: thirdRopeGuardSelection.length > 0 && selectedThirdRopeGuard==null, my_input_background_color_at_validInput: thirdRopeGuardSelection.length==0 || selectedThirdRopeGuard!=null}">
                                    <option v-if="thirdRopeGuardSelection.length>0" value="null" hidden>{{$t('3174')}}</option>
                                    <option v-if="thirdRopeGuardSelection.length>0" value="" hidden>{{$t('3174')}}</option>
                                    <option v-for="thirdRopeGuard in thirdRopeGuardSelection" v-bind:value="thirdRopeGuard">
                                        {{thirdRopeGuard.text.useTextKey?$t(thirdRopeGuard.text.textKey):thirdRopeGuard.text.textUI}}
                                    </option>
                                </select>
                            </div>
                            <div v-if="thirdRopeGuardSelection.length>0 && thirdRopeGuardSelection.length<=4">
                                <div style="display: grid;" v-bind:disabled="selectedCustomerIdKid==null || selectedCustomerIdKid=='' || deliverRopeDisabled==true" v-bind:class="{my_input_border_at_invalidInput: thirdRopeGuardSelection.length > 0 && selectedThirdRopeGuard==null, my_input_background_color_at_validInput: thirdRopeGuardSelection.length==0 || selectedThirdRopeGuard!=null}">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="thirdRopeGuard in thirdRopeGuardSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_thirdRopeGuard(thirdRopeGuard)" v-bind:checked="thirdRopeGuard.selected" v-bind:disabled="thirdRopeGuard.selected || deliverRopeDisabled==true" />
                                            <span style="margin-left:10px">{{thirdRopeGuard.text.useTextKey?$t(thirdRopeGuard.text.textKey):thirdRopeGuard.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!--<div v-if="tnruev!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div>{{$t('3586')}}:</div>
                            </div>
                            <div>
                                <div>{{tnruev}}</div>
                            </div>
                        </div>-->
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3543')}}:</div>
                            </div>
                            <div v-if="ropeClampSelection.length==0 || ropeClampSelection.length>4">
                                <select v-model="selectedRopeClamp" class="my_select" style="width:100%" v-bind:disabled="ropeClampSelection.length==0 || ropeClampSelectionDisabled">
                                    <option v-for="ropeClamp in ropeClampSelection" v-bind:value="ropeClamp">{{ropeClamp.text.textUI}}</option>
                                </select>
                            </div>
                            <div v-if="ropeClampSelection.length>0 && ropeClampSelection.length<=4">
                                <div style="display: grid;">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="ropeClamp in ropeClampSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_ropeClamp(ropeClamp)" v-bind:checked="ropeClamp.selected" v-bind:disabled="ropeClamp.selected || ropeClampSelectionDisabled" />
                                            <span style="margin-left:10px">{{ropeClamp.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                            <div>
                                <div class="ZAfont_family ZAfont_size">{{$t('3586')}}:</div>
                            </div>
                            <div v-if="rescueReturnDeviceSelection.length==0 || rescueReturnDeviceSelection.length>4">
                                <select v-model="selectedRescueReturnDevice" class="my_select" style="width:100%" v-bind:disabled="rescueReturnDeviceSelection.length==0 || rescueReturnDeviceSelectionDisabled">
                                    <option v-for="rescueReturnDevice in rescueReturnDeviceSelection" v-bind:value="rescueReturnDevice">{{rescueReturnDevice.text.textUI}}</option>
                                </select>
                            </div>
                            <div v-if="rescueReturnDeviceSelection.length>0 && rescueReturnDeviceSelection.length<=4">
                                <div style="display: grid;">
                                    <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                        <li v-for="rescueReturnDevice in rescueReturnDeviceSelection">
                                            <input type="checkbox" @input="change_Selected_atElementOf_rescueReturnDevice(rescueReturnDevice)" v-bind:checked="rescueReturnDevice.selected" v-bind:disabled="rescueReturnDevice.selected || rescueReturnDeviceSelectionDisabled" />
                                            <span style="margin-left:10px">{{rescueReturnDevice.text.textUI}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display:flex; justify-content: center; align-items: center">
                        <div v-if="imagePathRopeGuard!=null">
                            <Images :imageFilePath="imagePathRopeGuard" :maxImageHeight="250" :maxImageWidth="250"></Images>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import { configurations } from '../../../store/configurations.module';
    import { tractionSheaveManual } from '../../../store/tractionSheaveManual.module'
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import LoaderIcon from '../../loader/LoaderIcon';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    import TractionSheaveModal from '../../configuration/manualSteps/TractionSheaveModal';
    export default {
        name: 'RopeGuardModal',

        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
            TractionSheaveModal,
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            // Preselection traction sheave
            showTractionSheaveDetails: {
                get() {
                    return this.$store.state.tractionSheaveManual.showTractionSheaveDetails;
                },
            },
            tractionSheave_DiameterAndWidthSelection: {
                get() {
                    return this.$store.state.tractionSheaveManual.tractionSheave_DiameterAndWidthSelection;
                },
            },
            selectedTractionSheave_DiameterAndWidth: {
                get() {
                    return this.tractionSheave_DiameterAndWidthSelection != null && Array.isArray(this.tractionSheave_DiameterAndWidthSelection)
                        ? this.tractionSheave_DiameterAndWidthSelection.find(i => i.selected == true)
                        : null;
                },
                set(value) {
                    this.change_Selected_atElementOf_diameterAndWidth(value);
                }
            },

            // rope guard
            customerIdKidSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.customerIdKidSelection;
                },
            },
            selectedCustomerIdKid: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedCustomerIdKid'];
                },
                set(value) {
                    this.change_Selected_atElementOf_customerIdKid(value);
                }
            },
            positionMotorSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.positionMotorSelection;
                },
            },
            selectedPositionMotor: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedPositionMotor'];
                }
                ,
                set(value) {
                    this.change_Selected_atElementOf_positionMotor(value);
                }
            },
            ropePullSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.ropePullSelection;
                },
            },
            selectedRopePull: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedRopePull'];
                },
                set(value) {
                    this.change_Selected_atElementOf_ropePull(value);
                }
            },
            adjustabilitySelection: {
                get() {
                    return this.$store.state.ropeGuardManual.adjustabilitySelection;
                },
            },
            selectedAdjustability: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedAdjustability'];
                },
                set(value) {
                    this.change_Selected_atElementOf_adjustability(value);
                }
            },
            thirdRopeGuardSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.thirdRopeGuardSelection;
                },
            },
            selectedThirdRopeGuard: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedThirdRopeGuard'];
                },
                set(value) {
                    this.change_Selected_atElementOf_thirdRopeGuard(value);
                }
            },
            tnruev: {
                get() {
                    return this.$store.state.ropeGuardManual.tnruev;
                },

            },
            deliverRopeSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.deliverRopeSelection;
                },
            },
            selectedDeliverRope: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedDeliverRope'];
                },
                set(value) {
                    this.change_Selected_atElementOf_deliverRope(value);
                }
            },
            showDeliverRope: {
                get() {
                    return !Array.isArray(this.deliverRopeSelection) ||
                        !this.deliverRopeSelection.some(i =>
                            i.selected === true &&
                            i.text &&
                            i.text.code === 0
                        );
                },
                set(value) {
                    this.change_Selected_atElementOf_deliverRope(value);
                }
            },
            deliverRopeSelectionDisabled: {
                get() {
                    return false; //this.$store.getters['ropeGuardManual/deliverRopeSelectionDisabled'];
                },
            },
            tractionSheaveCover_Selection: {
                get() {
                    return this.$store.state.ropeGuardManual.tractionSheaveCoverSelection;
                },
            },

            tractionSheaveCoverSelection: {
                get() {
                    const value = this.tractionSheaveCover_Selection;
                    return value
                        && Object.prototype.hasOwnProperty.call(value, 'selection')
                        && Array.isArray(value.selection)
                        ? value.selection
                        : [];
                },
            },
            selectedTractionSheaveCover: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedTractionSheaveCover'];
                },
                set(value) {
                    this.change_Selected_atElementOf_tractionSheaveCover(value);
                }
            },
            tractionSheaveCoverSelectionDisabled: {
                get() {
                    return false; //this.$store.getters['ropeGuardManual/tractionSheaveCoverDisabled'];
                },
            },
            ropeClampSelection: {
                get() {
                    const value = this.$store.state.ropeGuardManual.ropeClampSelection;
                    return value
                        && Object.prototype.hasOwnProperty.call(value, 'selection')
                        && Array.isArray(value.selection)
                        ? value.selection
                        : [];
                },
            },
            selectedRopeClamp: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedRopeClamp'];
                },
                set(value) {
                    this.change_Selected_atElementOf_ropeClamp(value);
                }
            },
            ropeClampSelectionDisabled: {
                get() {
                    return this.$store.state.ropeGuardManual.ropeClampSelection != null && this.$store.state.ropeGuardManual.ropeClampSelection.hasOwnProperty('disabled')
                        ? this.$store.state.ropeGuardManual.ropeClampSelection.disabled
                        : true;
                },
            },
            rescueReturnDeviceSelection: {
                get() {
                    return this.$store.state.ropeGuardManual.rescueReturnDeviceSelection != null
                        && this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.hasOwnProperty('selection')
                        && Array.isArray(this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.selection)
                        ? this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.selection
                        : []; 
                },
            },
            selectedRescueReturnDevice: {
                get() {
                    return this.$store.getters['ropeGuardManual/selectedRescueReturnDevice'];
                },
                set(value) {
                    this.change_Selected_atElementOf_rescueReturnDevice(value);
                }
            },
            rescueReturnDeviceSelectionDisabled: {
                get() {
                    return (this.$store.state.ropeGuardManual.rescueReturnDeviceSelection != null && this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.hasOwnProperty('disabled')) ? this.$store.state.ropeGuardManual.rescueReturnDeviceSelection.disabled : true;
                },
            },
            deliverRopeDisabled: {
                get() {
                    return this.$store.state.ropeGuardManual.deliverRopeDisabled;
                }
            },
            SM250_TS280: {
                get() {
                    return this.$store.state.ropeGuardManual.sM250_TS280;
                },
                set(value) {
                    this.change_Selected_SM250_TS280(value);
                }
            },
            imagePathRopeGuard: {
                get() {
                    return this.selectedThirdRopeGuard != null && this.selectedThirdRopeGuard.hasOwnProperty('imagePathRopeGuard')
                        ? this.selectedThirdRopeGuard.imagePathRopeGuard
                        : null;
                }
            },
            statusModal_Shown: {
                get() {
                    return this.$store.state.statusHandling.statusModal_Shown;
                },
            },
        },

        created() {
            router.push('/');
            this.$store.dispatch('ropeGuardManual/set_ropeGuardManual_storeAction');
        },

        methods: {
            ValueDecimalSeparator(value) {
                if (value == null) {
                    return value;
                }

                return this.$get_decimalValueToLocaleString({
                    value,
                    country: this.$store.state.configurations.language,
                });
            },

            // traction sheave
            change_Selected_atElementOf_diameterAndWidth(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('tractionSheaveManual/change_tractionSheave_DiameterAndWidth_storeAction', value);
            },
            // Rope guard
            change_Selected_atElementOf_customerIdKid(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_customerIdKid_storeAction', value);
            },
            change_Selected_atElementOf_positionMotor(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_positionMotor_storeAction', value);
            },
            change_Selected_atElementOf_ropePull(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_ropePull_storeAction', value);
            },
            change_Selected_atElementOf_adjustability(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_adjustability_storeAction', value);
            },
            change_Selected_atElementOf_thirdRopeGuard(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_thirdRopeGuard_storeAction', value);
            },
            change_Selected_atElementOf_deliverRope(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_deliverRope_storeAction', value);
            },
            change_Selected_atElementOf_tractionSheaveCover(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_tractionSheaveCover_storeAction', value);
            },
            change_Selected_atElementOf_ropeClamp(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_ropeClamp_storeAction', value);
            },
            change_Selected_atElementOf_rescueReturnDevice(value) {
                this.$store.dispatch('inputsManual/checkIf_changesAt_configurationFlow_storeAction');
                this.$store.dispatch('ropeGuardManual/change_rescueReturnDevice_storeAction', value);
            },
        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
